(ns io.daskul.tutorial.webapp.domain.bootstrap.events
  "Boot/readiness orchestration (SMS-70).

   A single ::bootstrap event marks the boot started and fires the required
   up-front fetches (config + feature flags + active context). It is the one
   trigger for both fresh login (::auth/login-success) and reload-with-token
   (::auth/initialize) — replacing the duplicated dispatch trio at both sites.

   The readiness phase itself is a pure fn (io.daskul.webapp.bootstrap/phase)
   composed over db substate by ::bootstrap.subs/phase."
  (:require
   [re-frame.core :as rf]
   [io.daskul.webapp.config.events :as config.events]
   [io.daskul.tutorial.webapp.domain.feature-flags.events :as ff.events]
   [io.daskul.tutorial.webapp.domain.active-context.events :as ac.events]))

(rf/reg-event-fx
 ::bootstrap
 (fn [{:keys [db]} [_ {:keys [school-id branch-id available-contexts]}]]
   {:db (assoc-in db [:bootstrap :started?] true)
    :dispatch-n [[::config.events/fetch]
                 [::ff.events/fetch]
                 [::ac.events/initialize {:school-id school-id
                                          :branch-id branch-id
                                          :available-contexts available-contexts}]]}))
